import React from 'react'
import PrivateChatContainer from '../../../../Components/Apps/Chat/PrivateChat'

export default function PrivateChat() {
  return (
    <div className='page-body'>
        <PrivateChatContainer/>
    </div>
  )
}
